// extracted by mini-css-extract-plugin
module.exports = {"panel":"salt_panel__Sqb61","voteCount":"salt_voteCount__VIVr5"};